<script setup lang="ts">
/**
 * Le cadre de chaque page du module : l'écran hors offre à la place du
 * contenu quand l'entreprise n'a pas l'offre Energy Manager, sinon le contenu.
 *
 * La porte des routes a déjà jugé la garde serveur ; ce cadre ne juge que
 * l'offre, et suit la session sans rechargement.
 */
// ================================
// IMPORTS
// ================================
import { computed } from "vue"
import { useAuthStore } from "@core/stores/auth.store"

/**
 * La session connectée.
 */
const authStore = useAuthStore()

/**
 * Vrai quand l'entreprise a l'offre Energy Manager.
 */
const getAOffre = computed((): boolean => authStore.hasOfferEnergyManager)
</script>

<template>
    <!-- ================================ -->
    <!-- COMPOSANT PRINCIPAL -->
    <!-- ================================ -->
    <slot v-if="getAOffre" />
    <EcranHorsOffre v-else />
</template>
